<template>
  <LayoutMain>
    <!-- Page Header -->
    <header class="rounded-xl border border-outline-variant bg-surface-container-lowest p-5 shadow-sm">
      <div class="flex items-center gap-3">
        <button
          class="flex h-10 w-10 items-center justify-center rounded-full text-primary transition-colors hover:bg-primary-fixed"
          @click="goBack"
        >
          <ArrowLeft class="h-5 w-5" />
        </button>
        <div class="section-icon">
          <Shield class="h-5 w-5" />
        </div>
        <h1 class="font-headline text-headline-md text-primary">
          {{ t('adminView.title') }}
        </h1>
      </div>
    </header>

    <!-- Main Content with proper padding -->
    <main class="mt-6">
      <!-- Admin Panel Component -->
      <AdminPanel />
    </main>
  </LayoutMain>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ArrowLeft, Shield } from 'lucide-vue-next'
import AdminPanel from '../components/AdminPanel.vue'
import LayoutMain from '../components/ui/LayoutMain.vue'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()

function goBack() {
  router.back()
}
</script>

<style scoped>
.section-icon {
  @apply flex h-8 w-8 items-center justify-center rounded text-sm;
  background-color: var(--primary-fixed);
  color: var(--primary);
}
</style>
